// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zZzW","colBig":"styles_colBig__1y6aW","colSmall":"styles_colSmall__3TY2d"};